// GENERATED FILE - DO NOT MODIFY

export enum GetOfficeSpacesSortColumnDto {
    Name = "Name",
    Capacity = "Capacity",
}